import "./App.css";

import { lazy, Suspense } from "react";

import { BrowserRouter, Routes, Route, Navigate, useParams } from "react-router-dom";


const AdminPortal = lazy(() => import("./pages/AdminPortal"));

const ChutexOverview = lazy(() => import("./pages/chutex/ChutexOverview"));

const ChutexPeople = lazy(() => import("./pages/chutex/ChutexPeople"));

const ChutexPersonDetail = lazy(() => import("./pages/chutex/ChutexPersonDetail"));

const ChutexGuardians = lazy(() => import("./pages/chutex/ChutexGuardians"));

const ChutexProfessionals = lazy(() => import("./pages/chutex/ChutexProfessionals"));

const ChutexProfessionalDetail = lazy(() => import("./pages/chutex/ChutexProfessionalDetail"));

const ChutexPartnerReview = lazy(() => import("./pages/chutex/ChutexPartnerReview"));

const ChutexStructures = lazy(() => import("./pages/chutex/ChutexStructures"));

const ChutexStructureDetail = lazy(() => import("./pages/chutex/ChutexStructureDetail"));

const ChutexContracts = lazy(() => import("./pages/chutex/ChutexContracts"));
const ChutexRgpd = lazy(() => import("./pages/chutex/ChutexRgpd"));
const ChutexAcquisition = lazy(() => import("./pages/chutex/ChutexAcquisition"));

const ChutexContractDetail = lazy(() => import("./pages/chutex/ChutexContractDetail"));

const ChutexPayments = lazy(() => import("./pages/chutex/ChutexPayments"));

const ChutexFinances = lazy(() => import("./pages/chutex/ChutexFinances"));

const ChutexSiteAnalytics = lazy(() => import("./pages/chutex/ChutexSiteAnalytics"));

const ChutexNoraConversations = lazy(() => import("./pages/chutex/ChutexNoraConversations"));

const ChutexNoraExecutive = lazy(() => import("./pages/chutex/ChutexNoraExecutive"));

const ChutexDevices = lazy(() => import("./pages/chutex/ChutexDevices"));
const ChutexGlycemiaLab = lazy(() => import("./pages/chutex/ChutexGlycemiaLab"));

const ChutexContent = lazy(() => import("./pages/chutex/ChutexContent"));

const ChutexEditorialHub = lazy(() => import("./pages/chutex/ChutexEditorialHub"));

const ChutexEditorialJournal = lazy(() => import("./pages/chutex/ChutexEditorialJournal"));

const ChutexEditorialArticleEdit = lazy(() => import("./pages/chutex/ChutexEditorialArticleEdit"));

const ChutexAlerts = lazy(() => import("./pages/chutex/ChutexAlerts"));

const ChutexAlertDetail = lazy(() => import("./pages/chutex/ChutexAlertDetail"));

const ChutexNotificationDetail = lazy(() => import("./pages/chutex/ChutexNotificationDetail"));

const BddExplorer = lazy(() => import("./pages/BddExplorer"));

const Bracelet4GAdmin = lazy(() => import("./pages/Bracelet4GAdmin"));

const BeneficiarySubscriptions = lazy(() => import("./pages/BeneficiarySubscriptions"));

const CareOpsPage = lazy(() => import("./pages/care/CareOpsPage"));

const MemoryAdminPage = lazy(() => import("./pages/memory/MemoryAdminPage"));

const SocialHubLayout = lazy(() => import("./pages/social/SocialHubLayout"));
const SocialDashboard = lazy(() => import("./pages/social/SocialDashboard"));
const SocialCreate = lazy(() => import("./pages/social/SocialCreate"));
const SocialProjects = lazy(() => import("./pages/social/SocialProjects"));
const SocialProjectDetail = lazy(() => import("./pages/social/SocialProjectDetail"));
const SocialCalendar = lazy(() => import("./pages/social/SocialCalendar"));
const SocialProducts = lazy(() => import("./pages/social/SocialProducts"));
const SocialProductDetail = lazy(() => import("./pages/social/SocialProductDetail"));
const SocialAvatars = lazy(() => import("./pages/social/SocialAvatars"));
const SocialAvatarDetail = lazy(() => import("./pages/social/SocialAvatarDetail"));
const SocialBrain = lazy(() => import("./pages/social/SocialBrain"));
const SocialLibrary = lazy(() => import("./pages/social/SocialLibrary"));
const SocialNetworks = lazy(() => import("./pages/social/SocialNetworks"));
const SocialAnalytics = lazy(() => import("./pages/social/SocialAnalytics"));
const SocialSettings = lazy(() => import("./pages/social/SocialSettings"));
const SocialCampaigns = lazy(() => import("./pages/social/SocialCampaigns"));
const SocialEditorialPlan = lazy(() => import("./pages/social/SocialEditorialPlan"));

const ComptaLayout = lazy(() => import("./pages/compta/ComptaLayout"));
import ComptaProtectedRoute from "./pages/compta/ComptaProtectedRoute";
const ComptaOverview = lazy(() => import("./pages/compta/ComptaOverview"));
const ComptaLive = lazy(() => import("./pages/compta/ComptaLive"));
const ComptaSales = lazy(() => import("./pages/compta/ComptaSales"));
const ComptaSale360 = lazy(() => import("./pages/compta/ComptaSale360"));
const ComptaPurchases = lazy(() => import("./pages/compta/ComptaPurchases"));
const ComptaPurchase360 = lazy(() => import("./pages/compta/ComptaPurchase360"));
const ComptaBank = lazy(() => import("./pages/compta/ComptaBank"));
const ComptaVat = lazy(() => import("./pages/compta/ComptaVat"));
const ComptaAmazon = lazy(() => import("./pages/compta/ComptaAmazon"));
const ComptaDocuments = lazy(() => import("./pages/compta/ComptaDocuments"));
const ComptaAccounts = lazy(() => import("./pages/compta/ComptaAccounts"));
const ComptaClose = lazy(() => import("./pages/compta/ComptaClose"));
const ComptaAlerts = lazy(() => import("./pages/compta/ComptaAlerts"));
const ComptaVendors = lazy(() => import("./pages/compta/ComptaVendors"));

const GrowthLayout = lazy(() => import("./pages/growth/GrowthLayout"));
const GrowthCockpit = lazy(() => import("./pages/growth/GrowthCockpit"));
const GrowthOrganic = lazy(() => import("./pages/growth/GrowthOrganic"));
const GrowthOrganicScope = lazy(() => import("./pages/growth/GrowthOrganicScope"));
const GrowthOpportunities = lazy(() => import("./pages/growth/GrowthOpportunities"));
const GrowthAlerts = lazy(() => import("./pages/growth/GrowthAlerts"));
const GrowthHistory = lazy(() => import("./pages/growth/GrowthHistory"));
const GrowthDataSources = lazy(() => import("./pages/growth/GrowthDataSources"));
const GrowthSettings = lazy(() => import("./pages/growth/GrowthSettings"));
const GrowthAdvanced = lazy(() => import("./pages/growth/GrowthAdvanced"));
const ClosedLoopOverview = lazy(() => import("./pages/growth/ClosedLoopOverview"));
const ClosedLoopTaxonomy = lazy(() => import("./pages/growth/ClosedLoopTaxonomy"));
const ClosedLoopCampaigns = lazy(() => import("./pages/growth/ClosedLoopCampaigns"));
const ClosedLoopAssets = lazy(() => import("./pages/growth/ClosedLoopAssets"));
const ClosedLoopAssetDetail = lazy(() => import("./pages/growth/ClosedLoopAssetDetail"));
const ClosedLoopPerformance = lazy(() => import("./pages/growth/ClosedLoopPerformance"));
const ClosedLoopBreakdown = lazy(() => import("./pages/growth/ClosedLoopBreakdown"));
const ClosedLoopNewsletter = lazy(() => import("./pages/growth/ClosedLoopNewsletter"));
const ClosedLoopInfluence = lazy(() => import("./pages/growth/ClosedLoopInfluence"));
const ClosedLoopIntelligence = lazy(() => import("./pages/growth/ClosedLoopIntelligence"));
const ClosedLoopLearnings = lazy(() => import("./pages/growth/ClosedLoopLearnings"));
const ClosedLoopMissions = lazy(() => import("./pages/growth/ClosedLoopMissions"));
const ClosedLoopAutonomy = lazy(() => import("./pages/growth/ClosedLoopAutonomy"));

const NoraLayout = lazy(() => import("./pages/nora/NoraLayout"));
const NoraCommandHome = lazy(() => import("./pages/nora/NoraCommandHome"));
const NoraHealthChat = lazy(() => import("./pages/nora/NoraHealthChat"));
const NoraProspectionPage = lazy(() => import("./pages/nora/NoraProspectionPage"));
const NoraBriefPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraBriefPage })));
const NoraMachinesPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraMachinesPage })));
const NoraMachineDetailPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraMachineDetailPage })));
const NoraDetectionsPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraDetectionsPage })));
const NoraDetectionDetailPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraDetectionDetailPage })));
const NoraActionsPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraActionsPage })));
const NoraActionDetailPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraActionDetailPage })));
const NoraProvidersPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraProvidersPage })));
const NoraAlertsPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraAlertsPage })));
const NoraActivityPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraActivityPage })));
const NoraLearningsPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraLearningsPage })));
const NoraCrossChannelPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraCrossChannelPage })));
const NoraVerticalPage = lazy(() => import("./pages/nora/NoraPages").then((m) => ({ default: m.NoraVerticalPage })));

import CareProtectedRoute from "./pages/care/CareProtectedRoute";

import ChutexProtectedRoute from "./pages/chutex/ChutexProtectedRoute";

import { CareAuthProvider } from "./context/CareAuthContext";

import { ChutexAuthProvider } from "./context/ChutexAuthContext";

import { Toaster } from "sonner";

import { TooltipProvider } from "./components/ui/tooltip";


/* Admin v2 (DA Opus, 28/10/2026) : coquille, pages neuves (fichiers remplis par les lots L3 à L9) et chargement à la demande. */
const AdminShell = lazy(() => import("./admin/AdminShell"));
const Cockpit = lazy(() => import("./admin/pages/Cockpit"));
const Decisions = lazy(() => import("./admin/pages/Decisions"));
const Accueil = lazy(() => import("./admin/pages/Accueil"));
const Commandes = lazy(() => import("./admin/pages/Commandes"));
const CommandeDetail = lazy(() => import("./admin/pages/CommandeDetail"));
const Sav = lazy(() => import("./admin/pages/Sav"));
const SavDossier = lazy(() => import("./admin/pages/SavDossier"));
const Argent = lazy(() => import("./admin/pages/Argent"));
const Clients = lazy(() => import("./admin/pages/Clients"));
const ClientDetail = lazy(() => import("./admin/pages/ClientDetail"));
const Produits = lazy(() => import("./admin/pages/Produits"));
const Plus = lazy(() => import("./admin/pages/Plus"));
/* Planche des composants : développement seulement (absente du build de production). */
const DevUi = process.env.NODE_ENV === "development" ? lazy(() => import("./admin/dev/DevUi")) : null;

function RouteFallback() {
  return (
    <div className="admin-v2" style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", background: "#fff" }} aria-busy="true">
      <span className="adm-sk" style={{ display: "block", width: 180, height: 12 }} />
    </div>
  );
}


function LegacyPersonRedirect() {
  const { userId } = useParams();
  return <Navigate to={`/chutex/personnes/${userId}`} replace />;
}

function LegacyEditorialJournalRedirect() {
  const { journalSlug } = useParams();
  return <Navigate to={`/chutex/contenus/journal/${journalSlug}`} replace />;
}

function LegacyStructureRedirect() {
  const { structureId } = useParams();
  return <Navigate to={`/chutex/structures/${structureId}`} replace />;
}

function LegacyEditorialArticleRedirect() {
  const { journalSlug, articleId } = useParams();
  return <Navigate to={`/chutex/contenus/journal/${journalSlug}/${articleId}`} replace />;
}

function App() {

  return (

    <div className="App">

      <TooltipProvider delayDuration={250}>

        <CareAuthProvider>

          <ChutexAuthProvider>

          <BrowserRouter>

            <Suspense fallback={<RouteFallback />}>

            <Routes>

              <Route path="/" element={<AdminPortal />} />

              <Route path="/care/login" element={<Navigate to="/" replace />} />

              <Route element={<CareProtectedRoute />}>

                <Route path="/care" element={<CareOpsPage />} />

                <Route path="/care/*" element={<CareOpsPage />} />

                <Route path="/memory" element={<MemoryAdminPage />} />

                <Route path="/memory/*" element={<MemoryAdminPage />} />

              </Route>

              <Route path="/chutex/login" element={<Navigate to="/" replace />} />

              <Route element={<ChutexProtectedRoute />}>

              <Route path="/chutex" element={<AdminShell />}>

                <Route index element={<Accueil />} />

                <Route path="vue-ensemble" element={<ChutexOverview />} />

                <Route path="commandes" element={<Commandes />} />

                <Route path="commandes/:ref" element={<CommandeDetail />} />

                <Route path="sav" element={<Sav />} />

                <Route path="sav/:caseId" element={<SavDossier />} />

                <Route path="argent" element={<Argent />} />

                <Route path="clients" element={<Clients />} />

                <Route path="clients/:clientId" element={<ClientDetail />} />

                <Route path="produits" element={<Produits />} />

                <Route path="plus" element={<Plus />} />

                <Route path="cockpit" element={<Cockpit />} />

                <Route path="decisions" element={<Decisions />} />

                <Route path="personnes" element={<ChutexPeople />} />

                <Route path="personnes/:userId" element={<ChutexPersonDetail />} />

                <Route path="gardiens" element={<ChutexGuardians />} />

                <Route path="professionnels" element={<ChutexProfessionals />} />

                <Route path="professionnels/:userId" element={<ChutexProfessionalDetail />} />

                <Route path="partenaires" element={<ChutexPartnerReview />} />

                <Route path="structures" element={<ChutexStructures />} />

                <Route path="structures/:structureId" element={<ChutexStructureDetail />} />

                <Route path="alertes/:alertId" element={<ChutexAlertDetail />} />

                <Route path="alertes" element={<ChutexAlerts />} />

                <Route path="notifications/:notificationId" element={<ChutexNotificationDetail />} />

                <Route path="contrats" element={<ChutexContracts />} />
                <Route path="protection-des-donnees" element={<ChutexRgpd />} />
                <Route path="acquisition" element={<ChutexAcquisition />} />

                <Route path="contrats/:contractNumber" element={<ChutexContractDetail />} />

                <Route path="abonnements" element={<BeneficiarySubscriptions />} />

                <Route path="finances" element={<ChutexFinances />} />

                <Route path="site" element={<ChutexSiteAnalytics />} />

                <Route path="nora" element={<ChutexNoraConversations />} />

                <Route path="nora-executive" element={<ChutexNoraExecutive />} />

                <Route path="paiements" element={<ChutexPayments />} />

                <Route path="appareils" element={<ChutexDevices />} />

                <Route path="contenus" element={<ChutexContent />} />
                <Route path="contenus/journal/:journalSlug" element={<ChutexEditorialJournal />} />
                <Route path="contenus/journal/:journalSlug/:articleId" element={<ChutexEditorialArticleEdit />} />
                <Route path="contenus/editorial" element={<ChutexEditorialHub />} />
                <Route path="contenus/editorial/:journalSlug" element={<LegacyEditorialJournalRedirect />} />
                <Route path="contenus/editorial/:journalSlug/:articleId" element={<LegacyEditorialArticleRedirect />} />

                <Route path="developpement/bracelets-4g" element={<Bracelet4GAdmin />} />
                <Route path="developpement/glycemie" element={<ChutexGlycemiaLab />} />

                <Route path="developpement/bdd" element={<BddExplorer />} />

              </Route>

              {DevUi ? (
                <Route element={<AdminShell />}>
                  <Route path="/dev/ui" element={<DevUi />} />
                </Route>
              ) : null}

              <Route path="/social" element={<SocialHubLayout />}>

                <Route index element={<SocialDashboard />} />
                <Route path="create" element={<SocialCreate />} />
                <Route path="contents" element={<SocialProjects />} />
                <Route path="contents/:projectId" element={<SocialProjectDetail />} />
                <Route path="calendar" element={<SocialCalendar />} />
                <Route path="plan" element={<SocialEditorialPlan />} />
                <Route path="campaigns" element={<SocialCampaigns />} />
                <Route path="products" element={<SocialProducts />} />
                <Route path="products/:productId" element={<SocialProductDetail />} />
                <Route path="avatars" element={<SocialAvatars />} />
                <Route path="avatars/:avatarId" element={<SocialAvatarDetail />} />
                <Route path="brain" element={<SocialBrain />} />
                <Route path="library" element={<SocialLibrary />} />
                <Route path="networks" element={<SocialNetworks />} />
                <Route path="analytics" element={<SocialAnalytics />} />
                <Route path="settings" element={<SocialSettings />} />

              </Route>

              <Route element={<ComptaProtectedRoute />}>
                <Route path="/compta" element={<ComptaLayout />}>
                  <Route index element={<ComptaOverview />} />
                  <Route path="bilan" element={<ComptaLive />} />
                  <Route path="ventes" element={<ComptaSales />} />
                  <Route path="ventes/:order" element={<ComptaSale360 />} />
                  <Route path="achats" element={<ComptaPurchases />} />
                  <Route path="achats/:invoice" element={<ComptaPurchase360 />} />
                  <Route path="banque" element={<ComptaBank />} />
                  <Route path="rapprochements" element={<Navigate to="/compta/banque" replace />} />
                  <Route path="tva" element={<ComptaVat />} />
                  <Route path="amazon" element={<ComptaAmazon />} />
                  <Route path="marketplaces" element={<Navigate to="/compta/amazon" replace />} />
                  <Route path="documents" element={<ComptaDocuments />} />
                  <Route path="comptes" element={<ComptaAccounts />} />
                  <Route path="cloture" element={<ComptaClose />} />
                  <Route path="alertes" element={<ComptaAlerts />} />
                  <Route path="abonnements" element={<ComptaVendors />} />
                  <Route path="pieces" element={<Navigate to="/compta/alertes" replace />} />
                </Route>
              </Route>

              <Route path="/growth" element={<GrowthLayout />}>

                <Route index element={<GrowthCockpit />} />
                <Route path="organic" element={<GrowthOrganic />} />
                <Route path="organic/:vertical/:market" element={<GrowthOrganicScope />} />
                <Route path="opportunities" element={<GrowthOpportunities />} />
                <Route path="alerts" element={<GrowthAlerts />} />
                <Route path="history" element={<GrowthHistory />} />
                <Route path="data-sources" element={<GrowthDataSources />} />
                <Route path="settings" element={<GrowthSettings />} />
                <Route path="advanced" element={<GrowthAdvanced />} />
                <Route path="closed-loop" element={<ClosedLoopOverview />} />
                <Route path="closed-loop/taxonomy" element={<ClosedLoopTaxonomy />} />
                <Route path="closed-loop/campaigns" element={<ClosedLoopCampaigns />} />
                <Route path="closed-loop/assets" element={<ClosedLoopAssets />} />
                <Route path="closed-loop/assets/:assetId" element={<ClosedLoopAssetDetail />} />
                <Route path="closed-loop/performance" element={<ClosedLoopPerformance />} />
                <Route path="closed-loop/newsletter" element={<ClosedLoopNewsletter />} />
                <Route path="closed-loop/influence" element={<ClosedLoopInfluence />} />
                <Route path="closed-loop/influence/creators/:creatorId" element={<ClosedLoopInfluence />} />
                <Route path="closed-loop/intelligence" element={<ClosedLoopIntelligence />} />
                <Route path="closed-loop/learnings" element={<ClosedLoopLearnings />} />
                <Route path="closed-loop/missions" element={<ClosedLoopMissions />} />
                <Route path="closed-loop/autonomy" element={<ClosedLoopAutonomy />} />
                <Route path="closed-loop/breakdown" element={<ClosedLoopBreakdown />} />

              </Route>

              <Route path="/health" element={<NoraLayout />}>
                <Route index element={<NoraHealthChat />} />
              </Route>

              <Route path="/nora" element={<NoraLayout />}>
                <Route index element={<Navigate to="/health" replace />} />
                <Route path="details" element={<NoraCommandHome />} />
                <Route path="brief" element={<NoraBriefPage />} />
                <Route path="machines" element={<NoraMachinesPage />} />
                <Route path="machines/:machineId" element={<NoraMachineDetailPage />} />
                <Route path="detections" element={<NoraDetectionsPage />} />
                <Route path="detections/:detectionId" element={<NoraDetectionDetailPage />} />
                <Route path="actions" element={<NoraActionsPage />} />
                <Route path="actions/:actionId" element={<NoraActionDetailPage />} />
                <Route path="missions" element={<NoraCrossChannelPage />} />
                <Route path="prospection" element={<Navigate to="/prospection" replace />} />
                <Route path="providers" element={<NoraProvidersPage />} />
                <Route path="alerts" element={<NoraAlertsPage />} />
                <Route path="activity" element={<NoraActivityPage />} />
                <Route path="learnings" element={<NoraLearningsPage />} />
                <Route path="growth" element={<NoraVerticalPage name="growth" title="Growth" />} />
                <Route path="organic" element={<NoraVerticalPage name="organic" title="Organic FR" />} />
                <Route path="paid" element={<NoraVerticalPage name="paid" title="Paid Media" />} />
                <Route path="newsletter" element={<NoraVerticalPage name="newsletter" title="Newsletter" />} />
                <Route path="influence" element={<NoraVerticalPage name="influence" title="Influence" />} />
                <Route path="cro" element={<NoraVerticalPage name="cro" title="CRO" />} />
                <Route path="drl" element={<NoraVerticalPage name="drl" title="DRL" />} />
                <Route path="social" element={<NoraVerticalPage name="social" title="Social" />} />
              </Route>

              {/* Owner 15/09 : Prospection = branche principale de l'administration (tuile portail + menu), plus une URL cachée */}
              <Route path="/prospection" element={<NoraLayout />}>
                <Route index element={<NoraProspectionPage />} />
                <Route path=":tab" element={<NoraProspectionPage />} />
              </Route>

              </Route>

              {/* Raccourcis historiques */}

              <Route path="/personnes" element={<Navigate to="/chutex/personnes" replace />} />

              <Route path="/personnes/:userId" element={<LegacyPersonRedirect />} />

              <Route path="/gardiens" element={<Navigate to="/chutex/gardiens" replace />} />

              <Route path="/professionnels" element={<Navigate to="/chutex/professionnels" replace />} />

              <Route path="/structures" element={<Navigate to="/chutex/structures" replace />} />

              <Route path="/structures/:structureId" element={<LegacyStructureRedirect />} />

              <Route path="/contrats" element={<Navigate to="/chutex/contrats" replace />} />

              <Route path="/finances" element={<Navigate to="/chutex/finances" replace />} />

              <Route path="/paiements" element={<Navigate to="/chutex/paiements" replace />} />

              <Route path="/appareils" element={<Navigate to="/chutex/appareils" replace />} />

              <Route path="/contenus" element={<Navigate to="/chutex/contenus" replace />} />

              <Route path="/abonnements" element={<Navigate to="/chutex/abonnements" replace />} />

              <Route path="/bracelets-4g" element={<Navigate to="/chutex/developpement/bracelets-4g" replace />} />

              <Route path="/bdd" element={<Navigate to="/chutex/developpement/bdd" replace />} />

              <Route path="/developpement/abonnements" element={<Navigate to="/chutex/abonnements" replace />} />

              <Route path="/developpement/bracelets-4g" element={<Navigate to="/chutex/developpement/bracelets-4g" replace />} />

              <Route path="/developpement/bdd" element={<Navigate to="/chutex/developpement/bdd" replace />} />

              <Route path="/chutex-care" element={<Navigate to="/care" replace />} />

              <Route path="/schema" element={<Navigate to="/chutex/developpement/bdd" replace />} />

              <Route path="*" element={<Navigate to="/" replace />} />

            </Routes>

            </Suspense>

          </BrowserRouter>

          </ChutexAuthProvider>

        </CareAuthProvider>

      </TooltipProvider>

      <Toaster position="bottom-right" />

    </div>

  );

}



export default App;

